export default function getUniqueElementId(prefix = 'elem'): string {
  return `${prefix}-${Date.now().toString(16)}-${Date.now().toString(36)}`;
}
